import { render, staticRenderFns } from "./Registo.vue?vue&type=template&id=c44859f8&scoped=true&"
import script from "./Registo.vue?vue&type=script&lang=js&"
export * from "./Registo.vue?vue&type=script&lang=js&"
import style0 from "./Registo.vue?vue&type=style&index=0&id=c44859f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44859f8",
  null
  
)

export default component.exports